module.exports = __webpack_public_path__ + "img/amor-arm-0.c93182be.png";